module.exports = __webpack_public_path__ + "static/img/zyhh1.87d1767.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/zyhh1.png
// module id = 1283
// module chunks = 0